import { useSelector } from "react-redux";
import bankSvg from "../../assets/svg/bank.svg";
import svg5 from "../../assets/svg/svg5.svg";
import svg6 from "../../assets/svg/svg6.svg";
import svg7 from "../../assets/svg/svg7.svg";
import { cashConverter } from "../../utils";

 
export default function DashCard() {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  })); 
  
  const svgMap = {
    svg6,
    svg7,
  };
  const processedData = data?.cardSummary?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  return (
    <div className="grid gap-4 mt-[1.5rem]  grid-cols-[repeat(auto-fit,minmax(16rem,1fr))]">
      {processedData &&
        processedData?.map((item) => (
          <div className="dash-card   h-[8.25rem] ">
            <div className="h-1 bg-[rgba(255,182,0,0.40)] rounded-t-[0.5rem]"></div>
            <div className="px-[1rem] py-[1.5rem] flex flex-col font-lexendS text-[#000]">
              <div className="flex items-center justify-between">
                <div className=" text-[.85rem] font-[300] ">{item?.title}</div>
                <img src={svg5} alt="svg5" />
              </div>

              <div className="font-[500] text-[1rem] leading-[1.625rem]">
                {item?.title ==='Total Transactions' ? item?.amount : cashConverter(item?.amount)} 
              </div>
              <div className="mt-[.63rem] flex items-center gap-[.25rem]">
                <img src={svg6} alt="svg6" />
                <div className="text-[.75rem] font-[400] leading-4  text-[#333] flex items-center gap-[.2rem]">
                  {item?.percentage}{" "}
                  <span className=" !text-[#606060]">{item?.period}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
